import React from 'react';
import { adrift, bibleBookUrl } from '../data/books';
import useAdriftAvailability from '../hooks/useAdriftAvailability';
import './BooksPage.css';

function BooksPage() {
  const adriftAvailable = useAdriftAvailability();
  return (
    <div className="books-page">
      <h1>Books by D Byron</h1>
      <div className="books-container">
        {/* Hell a Fury */}
        <div className="book-item">
          <img src="/hell-a-fury-cover.jpg" alt="Hell a Fury Book Cover" />
          <h2>Hell a Fury</h2>
          <p>Maddie Callahan has spent years curating the perfect life. From the exclusive luncheons to the precise chill of her Veuve Clicquot, she commands her world with an iron grip wrapped in silk gloves. But when her husband, Jackson, returns from his latest business trip distant and distracted, Maddie senses the shift—the telltale cracks in a carefully constructed facade.</p>
          <div className="book-links">
            <a
              href="https://shop.ingramspark.com/b/084?params=ZGUZazcgj4ApUyHvDKzfiFlFARQx2UGIyTuAxyN6xCE"
              target="_blank"
              rel="noopener noreferrer"
              className="btn buy-now-btn"
            >
              Buy Now
            </a>
          </div>
        </div>

        {/* Short Stories */}
        <div className="book-item">
          <img src="/short-stories.jpg" alt="Short Stories Collection" />
          <h2>The Nature of Decisions: A Collection of Seven Short Stories</h2>
          <p>Delve into a world where everyday decisions unravel profound moral dilemmas. This collection of short stories offers a gripping exploration of realism and introspection, challenging readers to confront the complexities of human nature.</p>
          <div className="book-links">
             <a
               href="https://www.amazon.com/Nature-Decisions-Collection-Seven-Stories-ebook/dp/B0DV4375RV?ref_=ast_author_dp"
               target="_blank"
               rel="noopener noreferrer"
               className="btn buy-now-btn" // Added class
             >
               Buy Now
             </a>
          </div>
        </div>

        {/* Adrift */}
        <div className="book-item">
          <img src="/Adrift.jpg" alt="Adrift Book Cover" />
          <h2>Adrift</h2>
          <p className="book-availability">{adriftAvailable ? 'Available now' : 'Coming November 6, 2026'}</p>
          <p>A forgotten night. A stolen bag. A desperate escape. Cora wakes in a strange hotel room with a throbbing head, a fading bruise, and chilling gaps in her memory. Fleeing what she can't recall, she impulsively joins a volunteer trip to the Philippines, haunted by a military duffle bag she’s too afraid to open.</p>
          <div className="book-links">
            <a href={adrift.url} target="_blank" rel="noopener noreferrer" className="btn buy-now-btn">
              Buy Now
            </a>
          </div>
        </div>

        {/* Who Wrote the First Book of the Christian Bible? And Why Did They Do It? */}
        <div className="book-item">
          <img src="/Who Wrote The Bible.jpg" alt="Who Wrote the First Book of the Christian Bible? And Why Did They Do It? Book Cover" />
          <h2>Who Wrote the First Book of the Christian Bible? And Why Did They Do It?</h2>
          <p className="book-availability">Available now</p>
          <p>What if the story you were told about the origins of Christianity was never true? What if the first Gospel was not the testimony of a religious community, but a brilliant act of political engineering—written in the aftermath of the Jewish War by someone history has forgotten? In this provocative investigation, the origins and authorship of the Gospel of Mark. Striping away centuries of inherited assumptions and follows the surviving evidence into the chaotic world of Rome, Judea, and the aftermath of the destruction of Jerusalem.</p>
          <div className="book-links">
            <a href={bibleBookUrl} target="_blank" rel="noopener noreferrer" className="btn buy-now-btn">
              Buy Now
            </a>
          </div>
        </div>
      </div>
    </div>
  );
}

export default BooksPage;
